import {Injectable} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConversationNotFoundDialogComponent } from '../../views/partials/conversation-not-found/conversation-not-found.dialog.component';
import { ProjectNotFoundDialogComponent } from '../../views/partials/project-not-found/project-not-found.dialog.component';


@Injectable()
export class DialogService {

    constructor(public dialog: MatDialog) {        
    }

    projectNotFound() { 
        this.dialog.open(ProjectNotFoundDialogComponent, {
            width: '440px',
        });
    }

    conversationNotFound() {
        this.dialog.open(ConversationNotFoundDialogComponent, {
            width: '440px',
        });
    }
}
